import React from "react";

import
{
    useNamedRoutes
} from "../components/NamedRoutes";

import Layout from '../components/Layout/PriceList';
import Navbar from '../components/Navigation/Navbar/Settings';
import Sidebar from '../components/Navigation/Sidebar/Main';
import Statusbar from '../components/Navigation/Status/Main';

import PriceListOverview from "../components/PriceList/PriceListOverview";
import PriceListDetails from "../components/PriceList/PriceListDetails";

const PriceList: React.FC = () =>
{
    return (
        <Layout backbutton={true} sidebar={Sidebar} statusbar={Statusbar} navbar={Navbar} id="system" header={true}>
            <PriceListOverview />
        </Layout>

    );
};

const PriceListSetting: React.FC = () =>
{

    const { params } = useNamedRoutes();
    const { id } = params();

    return <Layout backbutton={true} sidebar={Sidebar} statusbar={Statusbar} navbar={Navbar} id="system" header={true}>
        <PriceListDetails priceListId={id || ""} />
    </Layout>;
};

export
{
    PriceList,
    PriceListSetting
};